<template>
  <form @submit.prevent="submit">
    <div class="border-t border-purple-gray px-4 sm:px-8 lg:px-16 py-6 w-full text-sm sm:text-base">
      <div class="mb-6">
        <h3 class="text-base sm:text-lg text-left text-primary font-semibold leading-snug">
          {{ $t('form.heading') }}
        </h3>
      </div>
      <div class="flex flex-wrap">
        <div
          :class="{'input-error': $v.contact.first_name.$anyError}"
          class="w-full sm:w-1/2 sm:pr-3 md:pr-6 mb-6 relative"
        >
          <label
            class="form-label mb-2"
            for="first_name"
          >
            {{ $t('form.name') }}
          </label>
          <input
            id="first_name"
            v-model.trim.lazy="$v.contact.first_name.$model"
            class="form-input"
            type="text"
          >
          <div class="error-group">
            <transition name="slide-up">
              <div
                v-if="!$v.contact.first_name.required && $v.contact.first_name.$dirty"
                key="nreq"
                class="text-error"
              >
                {{ $t('form.error') }}
              </div>
              <div
                v-if="!$v.contact.first_name.minLength && $v.contact.first_name.$dirty"
                key="nminlen"
                class="text-error"
              >
                Nazwa za krótka!
              </div>
            </transition>
          </div>
        </div>
        <div
          :class="{'input-error': $v.contact.last_name.$anyError}"
          class="w-full sm:w-1/2 sm:pl-3 md:pl-6 mb-6"
        >
          <label
            class="form-label mb-2"
            for="last_name"
          >
            {{ $t('form.surname') }}
          </label>
          <input
            id="last_name"
            v-model.trim.lazy="$v.contact.last_name.$model"
            class="form-input"
            type="text"
          >
          <div class="error-group">
            <transition name="slide-up">
              <div
                v-if="!$v.contact.last_name.required && $v.contact.last_name.$dirty"
                key="sreq"
                class="text-error"
              >
                {{ $t('form.error') }}
              </div>
              <div
                v-if="!$v.contact.last_name.minLength && $v.contact.last_name.$dirty"
                key="sminlen"
                class="text-error"
              >
                Nazwa za krótka!
              </div>
            </transition>
          </div>
        </div>
        <div
          :class="{'input-error': $v.contact.email.$anyError}"
          class="w-full"
        >
          <label
            class="form-label mb-2"
            for="email"
          >
            {{ $t('form.email') }}
          </label>
          <input
            id="email"
            v-model.trim.lazy="$v.contact.email.$model"
            class="form-input"
            type="email"
          >
          <div class="error-group">
            <transition name="slide-up">
              <div
                v-if="!$v.contact.email.required && $v.contact.email.$dirty"
                key="mreq"
                class="text-error"
              >
                {{ $t('form.error') }}
              </div>
              <div
                v-if="!$v.contact.email.email && $v.contact.email.$dirty"
                key="mail"
                class="text-error"
              >
                Nieprawidłowy email!
              </div>
            </transition>
          </div>
        </div>
      </div>
      <div class="flex pt-6">
        <div class="w-5 h-5 mt-1 mr-2">
          <InfoIcon />
        </div>
        <p class="text-xs sm:text-sm leading-loose">
          {{ $t('form.info') }}
        </p>
      </div>
    </div>
    <div class="border-t border-purple-gray px-4 sm:px-8 lg:px-16 py-6 w-full text-sm sm:text-base">
      <ul>
        <li class="mt-8">
          <label class="form-label flex items-start">
            <p
              class="text-xs font-normal text-purple-gray-dark leading-snug tracking-tight -mt-1"
              v-html="$t('form.permit')"
            />
          </label>
        </li>
      </ul>
      <div class="flex justify-center">
        <button
          :class="{'loading': loading}"
          class="btn h-14 px-9 mt-8 mb-3 flex items-center animate"
          type="submit"
        >
          {{ $t('form.submit') }}
          <transition name="zoom-in">
            <div
              v-if="loading"
              class="spinner w-5 h-5 ml-3 -mr-3 animate-spin"
            >
              <SpinnerIcon />
            </div>
          </transition>
        </button>
      </div>
    </div>
  </form>
</template>
<script>
import { mapActions } from 'vuex';
import {
  required,
  minLength,
  email,
} from 'vuelidate/lib/validators';
import SpinnerIcon from '@/assets/icons/spinner.svg';
import InfoIcon from '@/assets/icons/info.svg';
import { THANK_YOU } from '@/router/routes.names';

export default {
  name: 'Form',
  components: {
    SpinnerIcon,
    InfoIcon,
  },
  data() {
    return {
      contact: {
        first_name: '',
        last_name: '',
        email: '',
      },
      submitStatus: null,
      loading: false,
      responded: false,
      blocked: false,
    };
  },
  validations: {
    contact: {
      first_name: {
        required,
        minLength: minLength(3),
      },
      last_name: {
        required,
        minLength: minLength(2),
      },
      email: {
        required,
        email,
      },
    },
  },
  methods: {
    ...mapActions('order', ['sendOrder']),
    submit() {
      this.loading = true;
      setTimeout(() => {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.loading = false;
          this.submitStatus = 'ERROR';
        } else {
          this.submitStatus = 'PENDING';
          this.sendOrder({
            contact: this.contact,
            permits: { terms: true, processing: true },
          }).then(() => {
            this.submitStatus = 'OK';
            this.loading = false;
            this.$router.push({ name: THANK_YOU });
          });
        }
      }, 500);
    },
  },
};
</script>
<style lang="scss" scoped>
  button {
    position: relative;
    transition: all .5s ease;
    padding-right: 36px;
    &.loading {
      padding-right: 58px;
    }
  }
  .spinner {
    position: absolute;
    right: 36px;
    top: 18px;
  }
</style>
